export default class GeometryComponentFilter {
  filter(geom) {}
}
